<!-- Start Partner Area -->
<section class="listing-categories-area pt-100 pb-70">
    <div class="container">

        <div class="section-title">
            <h2>{{ 'Special_Occasion' | translate }}</h2>
            <p>{{ 'OccasionTXT' | translate}}</p>
        </div>


        <!--   <div class="partner-slides"> -->




        <!--data-aos="zoom-in-up"-->
        <div class="products-slides">
            <owl-carousel-o [options]="partnerSlidesOptions">
                <ng-template carouselSlide *ngFor="let item of dataSourceTag.data;">
                    <div class="partner-item">
                        <a (click)="onClickTag(item.inTagID)" href="javascript:void(0);">
                            <img [src]="apiURL + item.photoPath" alt="image" style="max-height:150px">
                        </a>
                        <h5 class="mt-3">
                            <ng-template *ngIf="SelectedLanguage == 'ar' ; then other_ItemAr  ; else other_ItemEn">
                            </ng-template>
                            <ng-template #other_ItemAr>{{ item.nameAr }}</ng-template>
                            <ng-template #other_ItemEn>{{ item.name }}</ng-template>
                        </h5>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>
    </div>
</section>
<!-- End Partner Area -->
